enum FormDataUrl {
  Tours = '/apiV1/destinationList/serp?slug=search',
  Hot = '/apiV1/destinationList/serp?slug=hot',
  Railway = '/apiV1/destinationList/serp?slug=railways_search',
  Hotels = '/apiV1/destinationList/serp?slug=hoteloffers_search',
}

export { FormDataUrl };
